import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ParentCard, PaginationButton, Pagination, HorizontalBar} from "./style";
import {
    Center,
    Box,
    Text,
    VStack,
    HStack,
} from '@chakra-ui/react';
import { Button } from "@chakra-ui/react";
import Select from "react-select";
import CardProposal from "../../../components/CardProposal";
import AuthService from "../../../services/auth.service";
import APIConfig from "../../../api/APIConfig";

import ReactLoading from "react-loading";
  
const ProposalMitra = (props) => {
    const [listProposal, setListProposal] = useState([]);
    const [idMitra, setIdMitra] = useState("");
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const pageNumbers = [];
    const [spinner, setSpinner] = useState(false);

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        console.log(user)
        setIdMitra(user.mitra[0].idMitra)
        console.log(user.mitra[0].idMitra)

        getListProposal(user.mitra[0].idMitra);
    }, [])

    const optionKategori = [
        { value: 0, label: "--- Pilih Status ---" },
        { value: 1, label: "Ditolak" },
        { value: 2, label: "Butuh Revisi" },
        { value: 3, label: "Dipublikasikan" },
        { value: 4, label: "Terkumpul" },
        { value: 5, label: "Batal" },
        { value: 6, label: "Selesai" },
    ]

    const getListProposal = async(idMitra) => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/proposal/mitra/${idMitra}`);
        const data = await response.data
        setListProposal(data);
        setSpinner(false);
    };

    const [selectedValue, setSelectedValue] = useState(0);


    const handleSearchKategori = (e) => {
        setSelectedValue(e.value);
        
    };

    const matcher = (data) => {
        console.log(selectedValue);
        if (selectedValue === 0) return true;
        else if (selectedValue === 1) {
            if (data.statusProposal === "Ditolak") return true;
        } else if (selectedValue === 2) {
            if (data.statusProposal ==="Butuh Revisi") return true;
        } else if (selectedValue === 3) {
            if (data.statusProposal ==="Dipublikasikan") return true;
        } else if (selectedValue === 4) {
            if (data.statusProposal ==="Terkumpul") return true;
        } else if (selectedValue === 5) {
            if (data.statusProposal === "Batal") return true;
        } else if (selectedValue === 6) {
            if (data.statusProposal === "Selesai") return true;
        }
        return false;
    };

    let data = listProposal;
    data = data.filter((i) => matcher(i));

    console.log(data.length);

    for (let i = 1; i <= Math.ceil(data.length / 10); i++) {
        pageNumbers.push(i);
    }

    const indexOfLastData = currentPage * 10;
    const indexOfFirstData = indexOfLastData - 10;
    data = data.slice(indexOfFirstData, indexOfLastData);
      
    if (spinner){
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return (
        <Center py={6}>
            <VStack align='stretch' fontFamily={'Inter'} pb={20}>   
                <Text
                    pt={10}
                    color={'gray.700'}
                    fontWeight={600}
                    fontSize={'2xl'}>
                    Daftar Proposal
                </Text>
                <HStack color={'gray.500'} pb={10}>
                    <Link to="/mitra/profile/proposal"> Daftar Proposal </Link>
                </HStack>
                <HStack pt={10} pr={10} justifyContent={"space-between"}>
                    <Select
                        borderRadius="50%"
                        fontSize='13px'
                        border='1px solid #F5F5F5'
                        height='100px' 
                        id='kategori' 
                        options={optionKategori}
                        onChange={handleSearchKategori}
                        value={optionKategori.find((obj) => obj.value === selectedValue)}
                        placeholder=" --- Status --- " />
                    <Button 
                        onClick={() => navigate(`/mitra/profile/proposal/form/${idMitra}`)}
                        fontSize='md' colorScheme='purple' variant='solid'>
                        Tambah Proposal
                    </Button>
                </HStack>

                <Box pt={5} align='center'>
                    {data.length > 0 ? 
                    <ParentCard>
                        <div style={{display: 'flex', flexWrap:'wrap'}}>
                            {data.map((data) => (
                                <div style={{flex: '40%', padding:"6px", margin:"6px"}}>
                                    <CardProposal
                                        id={data.idProposal}
                                        kegiatan={data.namaProposal}
                                        posisi={data.namaPosisi}
                                        status={data.statusProposal} />
                                </div>
                            ))}
                        </div>
                        <Box alignContent={'center'}>
                        {listProposal.length > 0 ? (<HorizontalBar last={true} />) : null}
                        {pageNumbers.length > 1 && (
                            <Pagination>
                                <PaginationButton onClick={() => 
                                    setCurrentPage(1)}>
                                    &lt;&lt;
                                </PaginationButton>
                                <PaginationButton onClick={() => 
                                    currentPage === 1 ? setCurrentPage(1) : setCurrentPage(currentPage-1)}>
                                    &lt;
                                </PaginationButton>
                                {pageNumbers.map((page) => (
                                    <PaginationButton
                                        unshow={
                                            currentPage > 2 && pageNumbers.length - currentPage > 1
                                            ? Math.abs(currentPage - page) > 2
                                            : pageNumbers.length - currentPage < 2
                                            ? pageNumbers.length - page > 4
                                            : page > 5
                                        }
                                        active={currentPage === page}
                                        onClick={() => setCurrentPage(page)}
                                        >
                                            {page}
                                    </PaginationButton>
                                ))}
                                <PaginationButton
                                    onClick={() =>
                                    currentPage === pageNumbers.length
                                        ? setCurrentPage(pageNumbers.length)
                                        : setCurrentPage(currentPage + 1)
                                    }
                                >
                                    &gt;
                                </PaginationButton>
                                <PaginationButton onClick={() => setCurrentPage(pageNumbers.length)}>
                                    &gt;&gt;
                                </PaginationButton>
                            </Pagination>
                            )}
                        </Box>
                    </ParentCard>
                    : 
                    <Text fontSize={"large"} fontWeight={'600'}>Tidak ada proposal</Text>
                    }
                </Box>
            </VStack>
        </Center>
    );
}

export default ProposalMitra;